import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import BMICalculator from '../../components/BMICalculator';

const BmiCalc: React.FC = () => (
  <ToolLayout
    title="BMI Calculator - Body Mass Index | AllTools"
    description="Calculate your Body Mass Index (BMI) instantly. Free BMI calculator with health category guidance."
    canonicalPath="/bmi-calculator"
  >
    <BMICalculator />
  </ToolLayout>
);

export default BmiCalc;
